import { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import StudentInfo from "./StudentInfo";
import { useLocation } from "react-router-dom";

function PrintChallan(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [voucheres, setVouchers] = useState([]);
  const [SchoolName, setSchoolName] = useState("");
  const [SchoolLogo, setSchoolLogo] = useState("");
  const [SchoolAddress, setSchoolAddress] = useState("");
  const [SchoolPhone, setSchoolPhone] = useState("");

  const location = useLocation();
  const [bank, setBank] = useState("");

  useEffect(() => {
    document.title = "Print Voucher";
    const fetchVouchers = async () => {
      setLoading(true);
      const urlParams = new URLSearchParams(window.location.search);

      const classId = urlParams.get("Class_Id");
      const wingId = urlParams.get("Wing_Id");
      const concessionRuleId = urlParams.get("ConcessionRuleID");
      const orderBy = urlParams.get("OrderBy");
      const registrationNo = urlParams.get("Registration_No");
      const sectionId = urlParams.get("Section_Id");
      const SessionId = urlParams.get("SessionID");
      const Description = urlParams.get("Description");
      const valuesSelected = urlParams.get("valuesSelected") || "";
      const challanNos = urlParams.get("ChallanNos") || "";
      const AdvanceMonths = urlParams.get("AdvanceMonths");
      const ShowHolidayImage = urlParams.get("ShowHolidayImage");
      const noRedCresent = urlParams.get("noRedCresent");
      const Amount = urlParams.get("amount");
      const Student_ID = urlParams.get("Student_ID");
      const StudentType = urlParams.get("StudentType");
      const showPreviousFee = urlParams.get("showPreviousFee");
      const feeCodes = urlParams.get("feeCodes") || "";
      const selectedMonth = urlParams.get("SelectedMonth");
      const fYear = urlParams.get("FYear");
      const paidStatusFilter = urlParams.get("PaidStatusFilter");
      const latestChallan = urlParams.get("latestChallan") === "1";

      const selectedArray = valuesSelected != "" ? valuesSelected.split(',').map(Number) : [];
      let selectedChallanNos = challanNos
        ? challanNos.split(",").map((val) => val.trim()).filter(Boolean)
        : [];

      const selectedFeeCodes = feeCodes != "" ? feeCodes.split(',').map(code => String(code.trim())) : [];

      if (latestChallan && selectedChallanNos.length === 0 && Student_ID) {
        try {
          const latestResp = await axios({
            method: "post",
            url: config.base_url + "ADLedger/GetLatestChallanByStudent",
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              AccessKey: AccessKey,
              UserID: UserID,
              MemberType: MemberType,
              Student_ID: Student_ID,
              Registration_No: registrationNo,
            },
          });

          if (latestResp.data && latestResp.data.status_code == 1 && latestResp.data.Challan_No) {
            selectedChallanNos = [latestResp.data.Challan_No];
          }
        } catch (error) {
          ////console.log(error);
        }
      }

      if (
        selectedChallanNos.length === 0 &&
        (wingId || classId || sectionId || selectedMonth || fYear || paidStatusFilter)
      ) {
        try {
          const headResp = await axios({
            method: "post",
            url: config.base_url + "MonthlyTask/GetChalanHeads",
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              AccessKey: AccessKey,
              UserID: UserID,
              MemberType: MemberType,
              pageNo: 1,
              pageSize: 100000,
              SessionID: SessionId,
              Wing_Id: wingId || 0,
              Class_Id: classId || 0,
              Section_Id: sectionId || 0,
              SelectedMonth: selectedMonth || 0,
              FYear: fYear || 0,
              PaidStatusFilter: paidStatusFilter || 0,
            },
          });
          if (
            headResp.data &&
            headResp.data.status_code === 1 &&
            Array.isArray(headResp.data.ListofRecords)
          ) {
            selectedChallanNos = headResp.data.ListofRecords
              .map((row) => row.Challan_No)
              .filter(Boolean);
          }
        } catch (error) {
          ////console.log(error);
        }
      }

      const data = selectedChallanNos.length > 0
        ? {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            Challan_Nos: selectedChallanNos,
            FeeCodes: selectedFeeCodes,
          }
        : {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            SelectedStudents: selectedArray,
            SessionID: SessionId,
            Class_Id: classId,
            Section_Id: sectionId,
            Wing_Id: wingId,
            ConcessionRuleID: concessionRuleId,
            Registration_No: registrationNo,
            SelectedMonth: selectedMonth,
            FYear: fYear,
            AdvanceMonths: AdvanceMonths,
            ShowHolidayImage: ShowHolidayImage,
            noRedCresent: noRedCresent,
            Description: Description,
            OrderBy: orderBy,
            Amount: Amount,
            Student_ID: Student_ID,
            StudentType: StudentType,
            AddTransportFee: showPreviousFee,
            SeletedClassNames: selectedFeeCodes,
          };

      const api_config = {
        method: "post",
        url:
          config.base_url +
          (selectedChallanNos.length > 0
            ? "ADLedger/PrintVouchersByChallanNos"
            : "ADLedger/PrintVouchersWithAD"),
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      try {
        const response = await axios(api_config);
        if (response.data.status_code == 1) {
          setVouchers(response.data.ListofRecords);
          setSchoolName(response.data.SchoolName);
          if (response.data.SchoolLogo) {
            const logoPath = response.data.SchoolLogo.replace(/^\/+/, "");
            setSchoolLogo(config.root + logoPath);
          }
          setSchoolAddress(response.data.SchoolAddress || "");
          setSchoolPhone(response.data.SchoolPhone || "");
          setBank(response.data.FeeVoucherStatement);
        }
      } catch (error) {
        ////console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchVouchers();
  }, []);


  const copyLabels = ["Bank Copy", "Office Copy", "Student Copy"];
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner animation="border" role="status"></Spinner>
      </div>
    );
  } else if (voucheres.length > 0) {
    return voucheres.map((item, index) => {
      //console.log("my", item);
      //console.log("bank", item.addBankCopy);
      const hasLedger = item.ReducedADLedger && item.ReducedADLedger.length > 0;
      const kuickpayId = item.Student_ID ? `15470${item.Student_ID}` : "";
      return (
        <>
          <div
            key={index}
            style={{
              backgroundColor: "#FFF",
              color: "#000",
              width: "100%",
              fontSize: "11px",
              display: "flex",
              justifyContent: "center",
            }}
            align="right"
          >
            <div
              style={{
                width: "297mm",
                height: "210mm",
                lineHeight: "18px",
                marginTop: "6mm",
                pageBreakAfter: "always",
              }}
            >
              <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
                <tbody>
                  <tr>
                    <td style={{ width: "33%" }} valign="top" align="left">
                      <StudentInfo
                        school={SchoolName}
                        schoolAddress={SchoolAddress}
                        schoolPhone={SchoolPhone}
                        logo={SchoolLogo}
                        studentcode={
                          item.Registration_No == ""
                            ? item.Student_ID + " (New Registration)"
                            : item.Registration_No
                        }
                        admissionNo={item.Registration_No}
                        className={item.Class_Name}
                        section={item.Section_Name}
                        name={item.Student_Name}
                        wing={item.Wing_Name}
                        father={item.Father_Name}
                        bank={bank}
                        copy={copyLabels[0]}
                        fee={item.ReducedADLedger || []}
                        dueDate={item.Challan_DueDate}
                        issueDate={item.Date_Of_Joining}
                        monthDate={
                          hasLedger
                            ? item.ReducedADLedger[0].PostingDate
                            : item.Date_Of_Joining
                        }
                        kuickpayId={kuickpayId}
                        challanNo={item.Challan_No}
                      />
                      {!hasLedger && (
                        <div style={{ fontSize: "11px", padding: "6px 0", color: "#a00" }}>
                          No fee details found for this challan.
                        </div>
                      )}
                    </td>
                    <td
                      style={{
                        width: "6mm",
                        borderLeft: "2px dashed black",
                      }}
                    ></td>
                      <td style={{ width: "33%" }} valign="top" align="left">
                        <StudentInfo
                          school={SchoolName}
                          schoolAddress={SchoolAddress}
                          schoolPhone={SchoolPhone}
                          logo={SchoolLogo}
                          studentcode={
                            item.Registration_No == ""
                              ? item.Student_ID + " (New Registration)"
                              : item.Registration_No
                          }
                          admissionNo={item.Registration_No}
                          className={item.Class_Name}
                          section={item.Section_Name}
                          name={item.Student_Name}
                          wing={item.Wing_Name}
                          father={item.Father_Name}
                          bank={bank}
                          copy={copyLabels[1]}
                          fee={item.ReducedADLedger || []}
                          dueDate={item.Challan_DueDate}
                          issueDate={item.Date_Of_Joining}
                          monthDate={
                            hasLedger
                              ? item.ReducedADLedger[0].PostingDate
                              : item.Date_Of_Joining
                          }
                          kuickpayId={kuickpayId}
                          challanNo={item.Challan_No}
                        />
                      </td>
                      <td
                        style={{
                          width: "6mm",
                          borderLeft: "2px dashed black",
                        }}
                      ></td>
                      <td style={{ width: "33%" }} valign="top" align="left">
                        <StudentInfo
                          school={SchoolName}
                          schoolAddress={SchoolAddress}
                          schoolPhone={SchoolPhone}
                          logo={SchoolLogo}
                          studentcode={
                            item.Registration_No == ""
                              ? item.Student_ID + " (New Registration)"
                              : item.Registration_No
                          }
                          admissionNo={item.Registration_No}
                          className={item.Class_Name}
                          section={item.Section_Name}
                          name={item.Student_Name}
                          wing={item.Wing_Name}
                          father={item.Father_Name}
                          bank={bank}
                          copy={copyLabels[2]}
                          fee={item.ReducedADLedger || []}
                          dueDate={item.Challan_DueDate}
                          issueDate={item.Date_Of_Joining}
                          monthDate={
                            hasLedger
                              ? item.ReducedADLedger[0].PostingDate
                              : item.Date_Of_Joining
                          }
                          kuickpayId={kuickpayId}
                          challanNo={item.Challan_No}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        );
    });
  }
}

export default PrintChallan;
